import loadable from '@loadable/component';

export const Component = loadable(() => import('./components/Comparator'));
export { default as propsFormatter } from './propsFormatter';
